export default function Intro({ goTo }) {
  return (
    <section className="section intro-section scene-mount">
      <div className="intro-inner">
        <p className="intro-greeting">hi, dua.</p>

        <h1 className="intro-title">shooters shoot.</h1>

        <p className="intro-italic">
          i could've just sent a normal "hey let's hang" — but if I'm a real
          shooter I have to match my effort with your worth.
        </p>

        <p className="intro-copy">
          so instead i made you a thing.
          <br />
          a few questions, a tiny game, and a small ask at the end.
          <br />
          take your time.
        </p>

        <button className="btn" onClick={() => goTo("questionnaire")}>
          <span className="btn-text">begin</span>
        </button>
      </div>
    </section>
  );
}
